// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--_mXrp","orange":"orange--2bpNl","blue":"blue--2qlrZ","title":"title--3e6Pz"};